import { Component, Input, OnChanges } from '@angular/core';
import { Activity } from '../models';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-strava-item',
  templateUrl: './strava-item.component.html',
  styleUrls: ['./strava-item.component.scss'],
  providers: [DatePipe],
})
export class StravaItemComponent implements OnChanges {
  @Input() activity: Activity;
  @Input() mapId = 'mapId';
  label: string;

  constructor(private datePipe: DatePipe) {}

  ngOnChanges() {
    this.generateLabel();
  }

  generateLabel() {
    const today = new Date();
    const activityDate = new Date(this.activity.start_date_local);
    const isToday =
      today.setHours(0, 0, 0, 0) === activityDate.setHours(0, 0, 0, 0);
    if (isToday) {
      this.label =
        'Today, at ' +
        this.datePipe.transform(
          new Date(this.activity.start_date_local),
          'HH:mm'
        );
    } else {
      this.label = this.datePipe.transform(
        new Date(this.activity.start_date_local),
        "MMMM d, y,' at' HH:mm"
      );
    }
  }
}
